<template>
	<div class="container">
		<div id="band-name-logo" class="image-container">
			<img src="/assets/img/bosb-logo-web-640x300.jpg" alt="Hand drawn text The Barred Owl Stringband"/>
		</div>
		<Youtube 
			:src="videoSrc" 
			:video-id="videoId"
			:player-options="playerOptions" 
			class="video-embed"
			:frameborder="0"
			:allow="playerOptions.allow"
			allowfullscreen
		/>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue'
// import { useHead } from '@vueuse/head'

			const videoId = ref('lGCax0QA24s')
			const playerOptions = {
				mute: 1,
				controls: 1,
				modestbranding: 1,
				rel: 0
			}
			// useHead({
			// 	title: 'The Barred Owl Stringband',
			// 	meta: [
			// 		{ property: 'og:type', content: 'website' },
			// 		{ property: 'og:title', content: 'The Barred Owl Stringband' },
			// 		{ property: 'og:description', content: 'The Barred Owl Stringband performs high energy americana and bluegrass music rooted in the oldtime mountain music traditions.' },
			// 		{ property: 'og:image', content: 'https://barredowlband.com/assets/img/bosb-social-og.jpg' },
			// 		{ property: 'og:image:width', content: '1200' },
			// 		{ property: 'og:image:height', content: '630' },
			// 		{ property: 'og:image:type', content: 'image/jpeg' },
			// 		{ property: 'og:url', content: 'https://barredowlband.com/' },
			// 		{ property: 'og:site_name', content: 'The Barred Owl Stringband' },
			// 		{ name: 'description', content: 'The Barred Owl Stringband performs high energy americana and bluegrass music rooted in the oldtime mountain music traditions.' },
			// 		{ name: 'twitter:card', content: 'summary_large_image' },
			// 		{ name: 'twitter:title', content: 'The Barred Owl Stringband' },
			// 		{ name: 'twitter:description', content: 'The Barred Owl Stringband performs high energy americana and bluegrass music rooted in the oldtime mountain music traditions.' },
			// 		{ name: 'twitter:image', content: 'https://barredowlband.com/assets/img/bosb-social-og.jpg' }
			// 	]
			// })

			const videoSrc = computed(() => `https://www.youtube.com/watch?v=${videoId.value}`)


	
</script>

<style scoped>
	/*styles*/
</style>